import { render, staticRenderFns } from "./ActivityTrip.vue?vue&type=template&id=6b3b08f0&scoped=true&"
import script from "./ActivityTrip.vue?vue&type=script&lang=js&"
export * from "./ActivityTrip.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTrip.vue?vue&type=style&index=0&id=6b3b08f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b08f0",
  null
  
)

export default component.exports